export const GET_KPI_METRICS_START = 'KPI/GET_KPI_METRICS_START';
export const GET_KPI_METRICS_SUCCESS = 'KPI/GET_KPI_METRICS_SUCCESS';
export const GET_KPI_METRICS_ERROR = 'KPI/GET_KPI_METRICS_ERROR';
export const UPDATE_KPI_METRICS = 'KPI/UPDATE_KPI_METRICS';
export const SET_INTERVAL_ID = 'KPI/SET_INTERVAL_ID';
